module.exports = __webpack_public_path__ + "static/media/ipnos-scenario-3.72b5fa6b.png";